export default class App {
    constructor() {
        this._resizeFunctionsArr = [];
        this._resizeFunctions = {};
        this._resizeFunctionsCounter = 0;
        this._resizeTimeout = null;
        this.resizeThrottle = false;

        this._scrollFunctionsArr = [];
        this._scrollFunctions = {};
        this._scrollFunctionsCounter = 0;
        this._scrollTimeout = null;
        this.scrollThrottle = false;

        this._resizeAnimationPreventerTimeout = 200;
		this._anchorEnhancementInstances = [];

        this.breakpoints = {
            xs: {
                gutter: 10,
                size: 0,
            },
            sm: {
                gutter: 30,
                size: 375,
            },
            md: {
                gutter: 30,
                size: 768,
            },
            ml: {
                gutter: 30,
                size: 1000,
            },
            lg: {
                gutter: 30,
                size: 1024,
            },
            xl: {
                gutter: 30,
                size: 1440,
            },
        };
    }

    init() {
        // this.detectBrowser();
        this.setEventListeners();
        this.fullHeightListener();
        // this.resizeAnimationPreventer();
        this.updateBreakpointData();
        // this.addNewWindowTitles();
        // this.addNoOpener();
		// this.addAnchorEnhancement();
        // this.initScrollTo();
        // this.initScrollToTop();
        this.initLabelClick();
        this.initTippy();

        return true;
    }

    setEventListeners() {
        window.addEventListener('resize', this.resize.bind(this), {
            passive: true,
        });
        document.addEventListener('scroll', this.scroll.bind(this), {
            passive: true,
        });

        document.querySelectorAll('main form label').forEach((label) => {
            label.addEventListener('keydown', (e) => {
                if (e.key.toLowerCase().substr(0, 3) == 'ent') {
                    label.click();
                }
            });
        });
    }

    resize() {
        const runFunctions = () => {
            for (
                let i = 0, length = this._resizeFunctionsArr.length;
                i < length;
                i++
            ) {
                this._resizeFunctionsArr[i]();
            }
        };
        if (this._resizeTimeout !== null) {
            return;
        }
        runFunctions();
        if (this.resizeThrottle) {
            this._resizeTimeout = setTimeout(() => {
                this._resizeTimeout = null;
                runFunctions();
            }, this.resizeThrottle);
        }
    }

    /**
     * @param {function} func Function to be called on a resize event
     */
    registerResizeEvent(func) {
        this._resizeFunctions[this._resizeFunctionsCounter] = func;
        this._resizeFunctionsCounter = this._resizeFunctionsCounter + 1;

        // Rebuild array of events
        this._resizeFunctionsArr = [];
        Object.keys(this._resizeFunctions).forEach((key) => {
            this._resizeFunctionsArr.push(this._resizeFunctions[key]);
        });

        return this._resizeFunctionsCounter - 1;
    }

    /**
     * @param {Number} func Function's ID to be removed from the resize functions
     */
    unregisterResizeEvent(func) {
        if (this._resizeFunctions[func]) {
            // Found
            delete this._resizeFunctions[func];

            // Rebuild array of events
            this._resizeFunctionsArr = [];
            Object.keys(this._resizeFunctions).forEach((key) => {
                this._resizeFunctionsArr.push(this._resizeFunctions[key]);
            });

            return true;
        } else {
            // Not found
            return false;
        }
    }

    /**
     * @description Fires all registered events for a scroll event in the document
     */
    scroll() {
        const runFunctions = () => {
            for (
                let i = 0, length = this._scrollFunctionsArr.length;
                i < length;
                i++
            ) {
                this._scrollFunctionsArr[i]();
            }
        };
        if (this._scrollTimeout !== null) {
            return;
        }
        runFunctions();
        if (this.scrollThrottle) {
            this._scrollTimeout = setTimeout(() => {
                this._scrollTimeout = null;
                runFunctions();
            }, this.scrollThrottle);
        }
    }

    /**
     * @param {function} func Function to be called on a scroll event
     */
    registerScrollEvent(func) {
        this._scrollFunctions[this._scrollFunctionsCounter] = func;
        this._scrollFunctionsCounter = this._scrollFunctionsCounter + 1;

        // Rebuild array of events
        this._scrollFunctionsArr = [];
        Object.keys(this._scrollFunctions).forEach((key) => {
            this._scrollFunctionsArr.push(this._scrollFunctions[key]);
        });

        return this._scrollFunctionsCounter - 1;
    }

    /**
     * @param {Number} func Function's ID to be removed from the scroll functions
     */
    unregisterScrollEvent(func) {
        if (this._scrollFunctions[func]) {
            // Found
            delete this._scrollFunctions[func];

            // Rebuild array of events
            this._scrollFunctionsArr = [];
            Object.keys(this._scrollFunctions).forEach((key) => {
                this._scrollFunctionsArr.push(this._scrollFunctions[key]);
            });

            return true;
        } else {
            // Not found
            return false;
        }
    }

    /**
     * @description Adds a 'preventAnimations' class to the html tag on resizing
     */
    resizeAnimationPreventer() {
        this.resizeTimer = null;
        this.registerResizeEvent(() => {
            document.documentElement.classList.add('preventAnimations');
            clearTimeout(this.resizeTimer);

            this.resizeTimer = setTimeout(() => {
                document.documentElement.classList.remove('preventAnimations');
            }, this._resizeAnimationPreventerTimeout);
        });
    }

    /**
     * @description Adds a CSS variable '--fullHeight' to the html tag that creates an 'accurate 100vh'
     */
    fullHeightListener() {
        const fullHeight = () => {
            document.documentElement.style.setProperty(
                '--fullHeight',
                `${window.innerHeight}px`
            );
        };
        this.registerResizeEvent(fullHeight);
        fullHeight();
    }

    /**
     * @description Adds a browser-specific class to the html tag
     */
    detectBrowser() {
        // Opera 8.0+
        let isOpera =
            (!!window.opr && !!opr.addons) ||
            !!window.opera ||
            navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        let isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]"
        let isSafari =
            /constructor/i.test(window.HTMLElement) ||
            (function (p) {
                return p.toString() === '[object SafariRemoteNotification]';
            })(
                !window['safari'] ||
                    (typeof safari !== 'undefined' && safari.pushNotification)
            );

        // Internet Explorer 6-11
        let isIE = /*@cc_on!@*/ false || !!document.documentMode;

        // Edge 20+
        let isEdge = !isIE && !!window.StyleMedia;

        // Chrome 1 - 71
        let isChrome =
            /Chrome/.test(navigator.userAgent) &&
            /Google Inc/.test(navigator.vendor);

        // Blink engine detection
        let isBlink = (isChrome || isOpera) && !!window.CSS;

        if (isOpera) {
            document.documentElement.classList.add('opera');
        }

        if (isFirefox) {
            document.documentElement.classList.add('firefox');
        }

        if (isSafari) {
            document.documentElement.classList.add('safari');
        }

        if (isIE) {
            document.documentElement.classList.add('ie');
        }

        if (isEdge) {
            document.documentElement.classList.add('edge');
        }

        if (isChrome) {
            document.documentElement.classList.add('chrome');
        }

        if (isBlink) {
            document.documentElement.classList.add('blink');
        }
    }

    updateBreakpointData() {
        if (this.breakpoints != null) {
            const styles = getComputedStyle(document.documentElement);

            Object.keys(this.breakpoints).forEach((breakpoint) => {
                const size = styles.getPropertyValue(
                    `--breakpoint-${breakpoint}-size`
                );
                const gutter = styles.getPropertyValue(
                    `--breakpoint-${breakpoint}-gutter`
                );

                if (size && !isNaN(parseInt(size))) {
                    this.breakpoints[breakpoint].size = parseInt(size);
                }

                if (gutter && !isNaN(parseInt(gutter))) {
                    this.breakpoints[breakpoint].gutter = parseInt(gutter);
                }
            });
        }
    }

    /**
     * @description Appends text to a tags that tells the user it'll open in a new tab/window. Add a tag with `data-new-window-text` property to change the appended text
     */
    addNewWindowTitles() {
        let text = '(opens in a new tab)';
        if (document.querySelector('[data-new-window-text]')) {
            text = document.querySelector('[data-new-window-text]').dataset
                .newWindowText;
        }

        document.querySelectorAll('a[target="_blank"]').forEach((a) => {
            a.setAttribute(
                'title',
                `${a.getAttribute('title')} ${text}`.trim().replace(/  /g, ' ')
            );
        });
    }

    /**
     * @description Adds the attribute 'rel' set to 'noopener' on external links; This is for security reasons/best practices
     */
    addNoOpener() {
        document.querySelectorAll('a').forEach((a) => {
            if (a.href && !a.hasAttribute('rel')) {
                if (a.hostname != location.hostname) {
                    a.setAttribute('rel', 'noopener');
                }
            }
        });
    }

    /**
     * @description Scroll element into view
     */
    initScrollTo() {
        const defaultOffset = 100; // Makes it so the target usually doesn't hide under the header

        document.querySelectorAll('[data-scroll-to]').forEach((el) => {
            el.addEventListener('click', (e) => {
                const target = document.querySelector(el.dataset.scrollTo);
                if (target && 'scrollTo' in window) {
                    e.preventDefault();

                    let scrollPosition = this.elementCoords(target).top;
                    if (
                        el.dataset.scrollOffset &&
                        !Number.isNaN(Number.parseInt(el.dataset.scrollOffset))
                    ) {
                        scrollPosition -= Number.parseInt(
                            el.dataset.scrollOffset
                        );
                    } else {
                        scrollPosition -= defaultOffset;
                    }

                    window.scrollTo({
                        top: scrollPosition,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }

    initScrollToTop() {
        this.scrollToTopContainer = document.querySelector('.scrollToTop');

        if (this.scrollToTopContainer) {
            const button = this.scrollToTopContainer.querySelector('button');
            const scroll = () => {
                if (document.documentElement.scrollTop > 400) {
                    this.scrollToTopContainer.classList.add('active');
                } else {
                    this.scrollToTopContainer.classList.remove('active');
                }
            };

            this.registerScrollEvent(scroll.bind(this));

            button.addEventListener('click', () => {
                this.scrollToTopContainer.classList.add('moving');
                button.blur();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
                setTimeout(
                    () => this.scrollToTopContainer.classList.remove('moving'),
                    1500
                );
            });
        }
    }

    /**
     * @description Tooltip library
     */
    initTippy() {
        if (
            document.querySelectorAll('[data-tippy-content]').length ||
            document.querySelectorAll('[data-tippy-source]').length
        ) {
            try {
                import(
                    /* webpackChunkName: "modules/tooltip" */ 'tippy.js'
                ).then((e) => {
                    const tippy = e.default;
                    tippy('[data-tippy-content]');

                    if (
                        document
                            .querySelectorAll('[data-tippy-source]')
                            .forEach((source) => {
                                const target = document.querySelector(
                                    `[data-tippy-target="${source.dataset.tippySource}"]`
                                );
                                if (target) {
                                    tippy(source, {
                                        allowHTML: true,
                                        content: target.innerHTML,
                                        //showOnCreate: true,
                                        interactive:
                                            target.querySelectorAll('a, button')
                                                .length > 0,
                                    });
                                }
                            })
                    );
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    /**
     * @description Makes tags with the data-copy property clickable, copies its content to the clipboard
     */
    initCopy() {
        document.querySelectorAll('[data-copy]').forEach((el) => {
            el.addEventListener('click', () => {
                try {
                    const copyContent = el.dataset.copy;
                    const input = document.createElement('input');

                    input.type = 'text';
                    input.style.position = 'absolute';
                    input.style.height = 0;
                    input.style.overflow = 'hidden';
                    input.value = copyContent;

                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    input.parentNode.removeChild(input);
                } catch (e) {
                    this.toast('Something unexpected went wrong', 'error');
                    console.error(e);
                }
            });
        });
    }

    /**
     * @description Makes sure labels that target an input become accessible using keyboard controls
     */
    initLabelClick() {
        document.querySelectorAll('label[for]').forEach((label) => {
            label.addEventListener('keydown', (e) => {
                switch (e.key.toLowerCase()) {
                    case ' ':
                        e.preventDefault();
                    case 'space':
                    case 'enter':
                        label.click();
                        break;
                }
            });
        });
    }

    /**
     * @description Makes sure anchored tags get a class for it, so offsetting scroll is possible. Also edit anchor links to get the [data-scroll-to] attribute
     */
    addAnchorEnhancement() {
        // Enhance anchors
        Array.from(document.querySelectorAll('a[id]'))
            .filter((a) => !a.href)
            .forEach((a) => {
                // Get parent element, add 'anchored' class
                if (a.parentElement) {
                    a.parentElement.classList.add('anchored');
                }
            });

        // Enhance anchor links
        Array.from(document.querySelectorAll('a[href]'))
            .filter(
                (a) =>
                    a.hash &&
                    a.hash != '' &&
                    a.getAttribute('href').substr(0, 1) == '#' &&
                    !a.dataset.scrollTo &&
                    !this._anchorEnhancementInstances.includes(a)
            )
            .forEach((a) => {
                a.dataset.scrollTo = a.hash;
                this._anchorEnhancementInstances.push(a);
            });
    }

    /**
     * @description Retrieves absolute position of an element relative to the page
     * @param {HTMLElement} el
     * @returns {Object}
     */
    elementCoords(el) {
        const box = el.getBoundingClientRect();

        const body = document.body;
        const docEl = document.documentElement;

        const scrollTop =
            window.pageYOffset || docEl.scrollTop || body.scrollTop;
        const scrollLeft =
            window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        const clientTop = docEl.clientTop || body.clientTop || 0;
        const clientLeft = docEl.clientLeft || body.clientLeft || 0;

        const top = box.top + scrollTop - clientTop;
        const left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }

    getParameter(name) {
        let result = null,
            tmp = [];
        let items = location.search.substr(1).split('&');
        for (let index = 0; index < items.length; index++) {
            tmp = items[index].split('=');
            if (tmp[0] === name) {
                result = decodeURIComponent(tmp[1]);
            }
            if (result === 'undefined') {
                result = true;
            }
        }
        return result;
    }

    insertTesters() {
        this.insertBreakpointIndicator();
        this.insertColumnTester();
    }

    insertColumnTester() {
        let tester = document.createElement('div');
        tester.classList.add('columnTester');
        let cols = ``;
        for (let i = 0; i < 12; i++) {
            cols += `<div class="col-1"><div></div></div>`;
        }
        tester.innerHTML = `<div class="container"><div class="row">${cols}</div></div>`;
        document.body.appendChild(tester);
    }

    insertBreakpointIndicator() {
        const breakpoints = Object.keys(this.breakpoints);
        let blocks = ``;
        breakpoints.forEach((breakpoint, index) => {
            let classes = 'col ';
            if (index == 0) {
                classes += `d-${breakpoints[index + 1]}-none`;
            } else if (index == breakpoints.length - 1) {
                classes += `d-none d-${breakpoint}-block`;
            } else {
                classes += `d-none d-${breakpoint}-block d-${
                    breakpoints[index + 1]
                }-none`;
            }
            blocks += `<div class="${classes}"><div class="breakpointIndicator">${breakpoint}</div></div>`;
        });

        let tester = document.createElement('div');
        tester.classList.add('breakpointIndicators');

        tester.innerHTML = `<div class="container"><div class="row">${blocks}</div></div>`;
        document.body.appendChild(tester);
    }
}